import React from "react";
import JobDetails from "./FormSteps/JobDetails";
import JobDescription from "./FormSteps/JobDescription";
import Benefits from "./FormSteps/Benefits";

const CurrentComponent = ({
  step,
  jobTitle,
  location,
  sector,
  salaryMin,
  salaryMax,
  description,
  handleTextInput,
  descriptionEditorOnChange,
  finishJobPostData,
  benefits,
  handleBenefits,
  jobType,
  handleJobType,
  salaryType,
  handleSalaryType,
  errors,
}) => {
  let currentComponent;

  const { sectorOptions, currency } = finishJobPostData;

  switch (step) {
    case 2:
      currentComponent = (
        <JobDescription
          description={description}
          descriptionEditorOnChange={descriptionEditorOnChange}
          errors={errors}
        />
      );
      break;
    case 3:
      currentComponent = (
        <Benefits
          benefits={benefits}
          handleBenefits={handleBenefits}
          errors={errors}
        />
      );
      break;
    default:
      currentComponent = (
        <JobDetails
          jobTitle={jobTitle}
          location={location}
          sector={sector}
          sectorOptions={sectorOptions}
          salaryMin={salaryMin}
          salaryMax={salaryMax}
          handleTextInput={handleTextInput}
          jobType={jobType}
          handleJobType={handleJobType}
          salaryType={salaryType}
          handleSalaryType={handleSalaryType}
          errors={errors}
          currency={currency}
        />
      );
  }
  return currentComponent;
};

export default CurrentComponent;
